import {useMutation} from "@tanstack/react-query";
import {ApiError, AssetsApi, UsersApi} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {addError, decrementLoading, incrementLoading} from "@/redux/meta/metaActions";
import {useDispatch, useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";

export function useDeleteAvatar() {
    const dispatch = useDispatch();
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    return useMutation({
        mutationFn: async (profilePictureId: string | undefined): Promise<void> => {
            dispatch(incrementLoading());
            try {
                if (profilePictureId) {
                    await new AssetsApi(getConfig(fullToken)).deleteAssetsId({id: profilePictureId});
                }
                await new UsersApi(getConfig(fullToken)).updateUsersRemoveProfilePicture();
            } finally {
                dispatch(decrementLoading());
            }
        },
        onError: async (e) => {
            dispatch(await addError(e as unknown as ApiError));
        },
    });
}
